import { render, staticRenderFns } from "./logisticsBox.vue?vue&type=template&id=d25d6878&scoped=true"
import script from "./logisticsBox.vue?vue&type=script&lang=js"
export * from "./logisticsBox.vue?vue&type=script&lang=js"
import style0 from "./logisticsBox.vue?vue&type=style&index=0&id=d25d6878&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d25d6878",
  null
  
)

export default component.exports